import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_part_of_the_comm_and_training_1'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_part_of_the_comm_and_training_1',
  name: 'Which of the following topics are part of the communication and training for individuals responsible for implementation?',
  description:
    'Individuals responsible for implementation may include human resources managers, operations managers, sourcing managers, line or shift supervisors, health and safety personnel, janitorial staff, security guards or other positions.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'RECRUITMENT_AND_HIRING',
      text: 'Recruitment and hiring',
      externalIds: [
        {
          id: 'ms-5--5-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SPECIFICALLY_FOR_MANAGERS_RESPONSIBLE_FOR_HIRING_NON_BIAS_IN_RE',
      text: 'Specifically for managers responsible for hiring: non-bias in recruitment of pregnant and married workers',
      externalIds: [
        {
          id: 'ms-do-14x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TERMINATION_AND_RETRENCHMENT',
      text: 'Termination and retrenchment',
      externalIds: [
        {
          id: 'ms-5--5-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_WORKPLACE_RULES',
      text: 'Facility workplace rules',
      externalIds: [
        {
          id: 'ms-5--5-3x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CHILD_LABOR_AND_YOUNG_WORKERS',
      text: 'Child labor and young workers',
      externalIds: [
        {
          id: 'ms-5--5-4x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PROHIBITION_OF_FORCED_LABOR',
      text: 'Prohibition of forced labor',
      externalIds: [
        {
          id: 'ms-5--5-5x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ANTI_HARASSMENT_AND_ABUSE',
      text: 'Anti-harassment and abuse',
      externalIds: [
        {
          id: 'ms-5--5-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ANTI_DISCRIMINATION',
      text: 'Anti-discrimination',
      externalIds: [
        {
          id: 'ms-5--5-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKING_HOURS',
      text: 'Working Hours',
      externalIds: [
        {
          id: 'ms-5--5-8x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WAGES_AND_BENEFITS',
      text: 'Wages and Benefits',
      externalIds: [
        {
          id: 'ms-5--5-9x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DISCIPLINE',
      text: 'Discipline',
      externalIds: [
        {
          id: 'ms-5--5-10x',
          version: 1.3,
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
      text: 'Freedom of association and collective bargaining',
      externalIds: [
        {
          id: 'ms-5--5-11x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'GRIEVANCE_SYSTEMS',
      text: 'Grievance systems',
      externalIds: [
        {
          id: 'ms-5--5-12x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKER_FEEDBACK',
      text: 'Worker Feedback',
      externalIds: [
        {
          id: 'ms-5--5-13x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HEALTH_AND_SAFETY',
      text: 'Health and safety',
      externalIds: [
        {
          id: 'ms-5--5-14x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all trainings offered to workers responsible for implementation of health and safety in the facility',
        externalIds: [
          {
            id: 'ms-do-15f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'MIGRANT_WORKERS',
      text: 'Migrant workers',
      externalIds: [
        {
          id: 'ms-5--5-16x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOMEWORKERS',
      text: 'Homeworkers',
      externalIds: [
        {
          id: 'ms-5--5-17x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SUPPLIERS_SUBCONTRACTORS',
      text: 'Suppliers/subcontractors',
      externalIds: [
        {
          id: 'ms-5--5-18x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'RAW_MATERIALS_SOURCING',
      text: 'Raw materials sourcing',
      externalIds: [
        {
          id: 'ms-do-16x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'BRIBERY_AND_ANTI_CORRUPTION',
      text: 'Bribery and anti-corruption',
      externalIds: [
        {
          id: 'ms-5--5-19x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-5--5-20x',
          version: 1.3,
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-5--5-20f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'RECRUITMENT_AND_HIRING',
                'SPECIFICALLY_FOR_MANAGERS_RESPONSIBLE_FOR_HIRING_NON_BIAS_IN_RE',
                'TERMINATION_AND_RETRENCHMENT',
                'FACILITY_WORKPLACE_RULES',
                'CHILD_LABOR_AND_YOUNG_WORKERS',
                'PROHIBITION_OF_FORCED_LABOR',
                'ANTI_HARASSMENT_AND_ABUSE',
                'ANTI_DISCRIMINATION',
                'WORKING_HOURS',
                'WAGES_AND_BENEFITS',
                'DISCIPLINE',
                'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
                'GRIEVANCE_SYSTEMS',
                'WORKER_FEEDBACK',
                'HEALTH_AND_SAFETY',
                'MIGRANT_WORKERS',
                'HOMEWORKERS',
                'SUPPLIERS_SUBCONTRACTORS',
                'RAW_MATERIALS_SOURCING',
                'BRIBERY_AND_ANTI_CORRUPTION',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-do-13',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 21850,
  sectionId: '2.2.6.12',
  impactArea: 'Management Systems',
  impactAreaId: 'MANAGEMENT_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
